import React from 'react';
import Home from './components/Home/Home'; // Import the component by name


function App() {
  return (
    <div className="App">
      <Home />
    </div>
  );
}

export default App;